import { initI18nResource } from '@/utils/pluginKit/utils';

import en_US from './en_US.yaml';
import zh_CN from './zh_CN.yaml';

initI18nResource({
  en_US,
  zh_CN,
});
